import { AccountSurveyActionResponse } from "~/entities/actions/types";
import {
  MEMBER_OTHER_ANSWER_ID,
  MEMBER_QUESTION_ID,
  MEMBER_SEARCH_ENGINE_ANSWER_ID,
  MEMBER_SOCIAL_MEDIA_ANSWER_ID,
  MEMBER_WORD_OF_MOUTH_ANSWER_ID,
} from "~/entities/survey/constants";
import useCreateAccountWizard from "~/hooks/useCreateAccountWizard";
import ErrorMessage from "./ErrorMessage";
import RadioField from "./RadioField";
import SubmitButton from "./SubmitButton";
import SurveyQuestion from "./SurveyQuestion";

type Props = {
  onSuccess: () => void;
  isActive: boolean;
};

const MemberSurvey: React.FC<Props> = ({ onSuccess, isActive }) => {
  const { errors, fetcher } =
    useCreateAccountWizard<AccountSurveyActionResponse>(onSuccess);

  if (!isActive) return null;

  return (
    <fetcher.Form
      method="post"
      action="/resources/create-account-wizard"
      className="flex flex-col gap-5"
      data-testid="member-survey-form"
    >
      <input
        type="hidden"
        name="intent"
        value="member_survey"
      />
      <h2 className="text-[20px] text-blue900 font-sans mt-0 uppercase font-bold">
        Customer survey
      </h2>

      <ErrorMessage error={errors["form"]} />

      <SurveyQuestion
        ordinal={1}
        question="Where did you hear about ShirtSpace.com?"
      >
        <RadioField
          id="search_engine"
          name={MEMBER_QUESTION_ID}
          value={MEMBER_SEARCH_ENGINE_ANSWER_ID}
        >
          Search engine
        </RadioField>
        <RadioField
          id="social_media"
          name={MEMBER_QUESTION_ID}
          value={MEMBER_SOCIAL_MEDIA_ANSWER_ID}
        >
          Social media
        </RadioField>
        <RadioField
          id="word_of_mouth"
          name={MEMBER_QUESTION_ID}
          value={MEMBER_WORD_OF_MOUTH_ANSWER_ID}
        >
          Word of mouth
        </RadioField>
        <RadioField
          id="other"
          name={MEMBER_QUESTION_ID}
          value={MEMBER_OTHER_ANSWER_ID}
        >
          Other
        </RadioField>
      </SurveyQuestion>
      <SubmitButton
        disabled={fetcher.state === "submitting"}
        label="Almost done"
      />
    </fetcher.Form>
  );
};

export default MemberSurvey;
